<template>
    <div class="login bg-gray-200 w-full min-h-screen flex md:items-center md:justify-center">
        <md-dialog-alert
            :md-active.sync="show"
            md-title="Chyba!"
            :md-content="errorMsg" />
        <div class="w-full flex items-center md:justify-center flex-col pt-6 md:pt-0">
            <img src="sixnet-logo.svg" class="h-20 mb-3 md-image" alt="Sixnet">
            <h1 class="mb-4 font-light text-xl">SIXNET INTRANET</h1>
            <div class="bg-white shadow-md md:w-1/5 lg:w-1/6">
                <form class="px-10 flex flex-col py-4" autocomplete="off" @submit="authenticate">
                    <h2 class="mb-4 text-center font-bold text-xl">Prihlásenie</h2>
                    <floating-label
                        :autocomplete="false"
                        :required="true"
                        :validation="emailValidator"
                        focus-color="orange"
                        name="email"
                        label="E-mail"
                        :value="email"
                        v-model="email" />
                    <floating-label
                        :autocomplete="false"
                        :validation="passValidator"
                        :required="true"
                        focus-color="orange"
                        name="password"
                        label="Heslo"
                        type="password"
                        :value="password"
                        v-model="password" />
                    <button v-ripple type="button" @click="authenticate" class="py-2 px-3 text-orange-500 text-sm hover:shadow w-24 ml-auto mr-auto text-center">Prihlásiť sa</button>
                    <button type="submit" class="hidden d-none"></button>
                </form>
            </div>
            <span class="text-xs text-gray-400 mt-6">Copyright {{ year }} by Sixnet. All Rights reserved.</span>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { EventBus } from '../utils'

export default {
  name: "home",
    metaInfo: {
        title: "Prihlásiť sa"
    },
    
    data() {
      return {
          email: "",
          password: "",
          year: moment().get("year"),
          errorMsg: '',
          show: false
      }
    },
    
    beforeCreate() {
        if (this.$store.getters.isAuthenticated) {
            this.$router.push('/dashboard')
        }
    },

    mounted () {
        EventBus.$on('failedAuthentication', (msg) => {
            if(typeof msg.response.data.message !== 'undefined')
                this.errorMsg = msg.response.data.message;
            else
                this.errorMsg = msg;
            
            this.show = true;
        });
    },
    
    beforeDestroy () {
        EventBus.$off('failedAuthentication');
    },
    
    methods: {
        authenticate (e = null) {
            if(e !== null) e.preventDefault();
            this.errorMsg = '';
            this.$store.dispatch('login', { email: this.email, password: this.password })
                .then(() => this.errorMsg.length > 0 ? '' : this.$router.push('/dashboard'))
        },
        
        closeModal() {
            this.show = false
        },
        
        emailValidator(value) {
            let re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
            return value.length > 4 && value.match(re);
        },
        
        passValidator(value) {
            return value.length > 4;
        }
    }
};
</script>
